(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wldk-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadGsap() {
    if (window.CU && typeof window.CU.loadGsap === 'function') {
      return window.CU.loadGsap();
    }
    if (window.gsap) {
      return Promise.resolve(window.gsap);
    }
    return Promise.reject(new Error('WLDK Hero: add cu-theme-global in theme.liquid (loads cu-window.js + GSAP).'));
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function initWldkHero(root) {
    if (!root || root.dataset.wldkHeroReady === 'true') {
      return;
    }

    if (prefersReducedMotion()) {
      root.dataset.wldkHeroReady = 'true';
      return;
    }

    loadGsap()
      .then(function (gsap) {
        if (!root.isConnected) {
          return;
        }

        if (root._wldkHeroCtx) {
          root._wldkHeroCtx.revert();
          root._wldkHeroCtx = null;
        }

        var ctx = gsap.context(function () {
          var potDefaults = { transformOrigin: '50% 50%' };

          gsap
            .timeline({ defaults: potDefaults })
            .from('.home-hero_pot-wrapper.is-beauty', {
              scale: 0,
              duration: 2,
              ease: 'elastic.out(0.9,0.4)',
            })
            .from('.home-hero_pot-wrapper.is-calming', {
              scale: 0,
              delay: -1.8,
              duration: 2,
              ease: 'elastic.out(0.9,0.4)',
            })
            .from('.home-hero_pot-wrapper.is-immunity', {
              scale: 0,
              delay: -1.8,
              duration: 2,
              ease: 'elastic.out(0.9,0.4)',
            })
            .from('.home-hero_pot-wrapper.is-beauty', {
              yPercent: 5,
              duration: 1.5,
              ease: 'power1.inOut',
              yoyo: true,
              delay: -1.8,
              repeat: -1,
            })
            .from('.home-hero_pot-wrapper.is-calming', {
              yPercent: 5,
              duration: 1.5,
              ease: 'power1.inOut',
              yoyo: true,
              delay: -2.5,
              repeat: -1,
            })
            .from('.home-hero_pot-wrapper.is-immunity', {
              yPercent: 5,
              duration: 1.5,
              ease: 'power1.inOut',
              yoyo: true,
              delay: -1,
              repeat: -1,
            });
        }, root);

        root._wldkHeroCtx = ctx;
        root.dataset.wldkHeroReady = 'true';
      })
      .catch(function () {
        /* GSAP failed to load — leave pots static */
      });
  }

  function destroyWldkHero(root) {
    if (!root) {
      return;
    }
    if (root._wldkHeroCtx) {
      root._wldkHeroCtx.revert();
      root._wldkHeroCtx = null;
    }
    delete root.dataset.wldkHeroReady;
  }

  function scanAndInit(container) {
    var scope = container || document;
    var nodes = scope.querySelectorAll('[data-wldk-hero-root]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-enable-pot-animation') !== 'false') {
        initWldkHero(nodes[i]);
      }
    }
  }

  function registerGlobalListenersOnce() {
    if (window.__wldkHeroListeners) {
      return;
    }
    window.__wldkHeroListeners = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scanAndInit();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      scanAndInit(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll('[data-wldk-hero-root]');
      for (var i = 0; i < roots.length; i++) {
        destroyWldkHero(roots[i]);
      }
    });
  }

  registerGlobalListenersOnce();
  scanAndInit();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wldk-subscribe-save"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadGsap() {
    if (window.CU && typeof window.CU.loadGsap === 'function') {
      return window.CU.loadGsap();
    }
    if (window.gsap) {
      return Promise.resolve(window.gsap);
    }
    return Promise.reject(new Error('WLDK Subscribe & Save: add cu-theme-global in theme.liquid (loads cu-window.js + GSAP).'));
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function initWldkSubSave(root) {
    if (!root || root.dataset.wldkSubSaveReady === 'true') {
      return;
    }

    if (prefersReducedMotion()) {
      root.dataset.wldkSubSaveReady = 'true';
      return;
    }

    loadGsap()
      .then(function (gsap) {
        if (!root.isConnected) {
          return;
        }

        if (root._wldkSubSaveCtx) {
          root._wldkSubSaveCtx.revert();
          root._wldkSubSaveCtx = null;
        }

        var ctx = gsap.context(function () {
          var potDefaults = { transformOrigin: '50% 50%' };

          gsap
            .timeline({ defaults: potDefaults })
            .from('.wldk-subsave__pot-wrapper.is-beauty', {
              scale: 0,
              duration: 2,
              ease: 'elastic.out(0.9,0.4)',
            })
            .from('.wldk-subsave__pot-wrapper.is-calming', {
              scale: 0,
              delay: -1.8,
              duration: 2,
              ease: 'elastic.out(0.9,0.4)',
            })
            .from('.wldk-subsave__pot-wrapper.is-immunity', {
              scale: 0,
              delay: -1.8,
              duration: 2,
              ease: 'elastic.out(0.9,0.4)',
            })
            .from('.wldk-subsave__pot-wrapper.is-beauty', {
              yPercent: 5,
              duration: 1.5,
              ease: 'power1.inOut',
              yoyo: true,
              delay: -1.8,
              repeat: -1,
            })
            .from('.wldk-subsave__pot-wrapper.is-calming', {
              yPercent: 5,
              duration: 1.5,
              ease: 'power1.inOut',
              yoyo: true,
              delay: -2.5,
              repeat: -1,
            })
            .from('.wldk-subsave__pot-wrapper.is-immunity', {
              yPercent: 5,
              duration: 1.5,
              ease: 'power1.inOut',
              yoyo: true,
              delay: -1,
              repeat: -1,
            });
        }, root);

        root._wldkSubSaveCtx = ctx;
        root.dataset.wldkSubSaveReady = 'true';
      })
      .catch(function () {
        /* GSAP failed to load — leave pots static */
      });
  }

  function destroyWldkSubSave(root) {
    if (!root) {
      return;
    }
    if (root._wldkSubSaveCtx) {
      root._wldkSubSaveCtx.revert();
      root._wldkSubSaveCtx = null;
    }
    delete root.dataset.wldkSubSaveReady;
  }

  function scanAndInit(container) {
    var scope = container || document;
    var nodes = scope.querySelectorAll('[data-wldk-subsave-root]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-enable-pot-animation') !== 'false') {
        initWldkSubSave(nodes[i]);
      }
    }
  }

  function registerGlobalListenersOnce() {
    if (window.__wldkSubSaveListeners) {
      return;
    }
    window.__wldkSubSaveListeners = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scanAndInit();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      scanAndInit(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll('[data-wldk-subsave-root]');
      for (var i = 0; i < roots.length; i++) {
        destroyWldkSubSave(roots[i]);
      }
    });
  }

  registerGlobalListenersOnce();
  scanAndInit();
})();

  } catch(e) { console.error(e); }
})();
})();
